module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.loadingFresh),
      callback: function($$v) {
        _vm.loadingFresh = $$v
      },
      expression: "loadingFresh"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.noMore,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loadingMore),
      callback: function($$v) {
        _vm.loadingMore = $$v
      },
      expression: "loadingMore"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('van-cell', {
      key: item.id
    }, [_c('span', {
      attrs: {
        "slot": "default"
      },
      slot: "default"
    }, [_c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.change > 0) ? _c('span', {
      staticClass: "list-right"
    }, [_vm._v("+" + _vm._s(item.change))]) : _c('span', {
      staticClass: "list-right"
    }, [_vm._v("-" + _vm._s(item.change))])])])])
  }), 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15c9b00c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailScore.vue
// module id = 1385
// module chunks = 0